<template>
  <div>
    <div class="content-header">
      <div class="left">
      <Input
          v-model="page.value"
          style="width:250px"
          placeholder="根据编号、企业名、电话搜索"
          @on-enter="getData(1)"
        >
          <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>

      <div class="right">
        <Select style="width:230px;margin-right:10px" filterable remote clearable :remote-method="searchCompany" @on-change="setCompany" placeholder="选择要充值的企业">
          <Option v-for="(option, index) in companys" :value="option.id" :key="index">{{option.company_name}}</Option>
        </Select>
        <span v-if="company.id">
          <span style="margin-right: 5px">{{company.company_name}}:</span>
          <InputNumber :active-change="false" style="width: 90px;margin-right:5px" :min="0.01" :precision="2" v-model="data.money" placeholder="充值金额"></InputNumber>
          <Input style="width: 200px;margin-right:5px" v-model="data.log" placeholder="备注..."/>
          <Button type="primary" @click="recharge">充值</Button>
        </span>
      </div>
    </div>
    <div>
      <Table size="small" :columns="columns" :data="log"/>
      <div class="t-right">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" :current="page.p + 1" show-elevator show-sizer show-total/>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      company: {},
      companys: [],
      searchRes: '',
      data: {
        company_id: 0,
        log: '',
        money: 0
      },
      page: {
        p: 0,
        l: 10
      },
      total: 0,

      columns: [
        { key: 'id', title: '编号' },
        { key: 'create_time',
          title: '充值时间',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          } },
        { key: 'agent_name', title: '合作伙伴' },
        { key: 'company_name', title: '企业' },
        { key: 'money', title: '金额' },
        { key: 'is_confirm',
          title: '状态',
          render: (h, data) => {
            return h('span', { style: { color: data.row.is_confirm ? '#19be6b' : '#ed4014' } }, data.row.is_confirm ? '已确认' : '待确认')
          } },
        { key: 'log', title: '备注' },
        { key: 'operate',
          title: '操作',
          width: '100',
          render: (h, data) => {
            if (!data.row.is_confirm) {
              return h('Button', {
                props: { type: 'success', size: 'small' },
                on: {
                  click: () => {
                    this.CompanyRechargeConfirm({ id: data.row.id }).then(res => {
                      this.getData()
                    })
                  }
                }
              }, '确认')
            }
          } }
      ],
      log: []
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.data.company_id = this.$route.query.id
      this.infoCompany({ id: this.$route.query.id }).then(res => {
        this.company = res[0]
      })
    }
    this.getData()
  },
  methods: {
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.CompanyRechargeLog(this.page).then(res => {
        this.log = res.data
        this.total = res.total
      })
    },
    recharge () {
      console.log(this.data)
      if (this.data.money > 0) {
        this.CompanyRecharge(this.data).then(res => {
          if (res) {
            this.$Message.success('充值成功')
            this.data = {
              company_id: 0,
              note: '',
              value: ''
            }
            this.getData()
          } else {
            this.$Message.error('充值失败')
          }
        })
      } else {
        this.$Message.error('充值金额有误')
      }
    },
    setCompany (id) {
      this.companys.map(item => {
        if (item.id === id) {
          this.company = item
          this.data.company_id = item.id
        }
      })
    },
    searchCompany (text) {
      this.SearchCompany({ text: text }).then(res => {
        this.companys = res
      })
    },
    reset () {
      this.page = {
        p: 0,
        l: 10
      }
      this.getData()
    },
    ...mapActions(['infoCompany', 'SearchCompany', 'CompanyRecharge', 'CompanyRechargeLog', 'CompanyRechargeConfirm'])
  }
}
</script>

<style lang="scss" scoped>

</style>
